export default {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    data() {
        return {
            severities: [
                {status: 'Approved', value: 'success'},
                {status: 'Rejected', value: 'error'},
                {status: 'Cancelled', value: 'warn'},
            ],
        }
    },
    methods: {
        filterSeverityByStatus: function(severities: any, value: any) {
            return severities.filter(function(severity : any) {
                if (severity.status == value) {
                    return severity;
                }
            });
        },
    }
};